import {API_URL, apiGet} from '../api'
import {ApiRes} from '../../types/api'

export interface ICopyLeaders {
    key_id: string
    leader_name: string
    thumbnail: string
    aum: number
    copiers: ICopier[]
    earn: number
    copier_count: number
    max_copier: number
    start_at: string
    expected_pay: number
}

export interface ICopier {
    key_id: string
    username: string
    thumbnail: string
    start_at: string
    balance: number
    pnl: number
    profit_rate: number
    paid_leader: number
    next_payment: string
    expected_pay: number
    pending_pay: boolean
}

export const getLeaderKeys = async (userId: string): Promise<ApiRes<ICopyLeaders[]>> => {
    return await apiGet(API_URL, `leader/keys/${userId}`)
}
